<script>
import chroma from 'chroma-js'
import { Radar } from 'vue-chartjs'

export default {
  name: 'RadarChart',
  extends: Radar,
  props: {
    data: {
      type: Object,
      required: true
    },
    options: {
      type: Object,
      default: () => {}
    },
    gradient: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    chartData() {
      return this.data
    }
  },
  watch: {
    data() {
      this._data._chart.destroy()
      this.renderRadarChart()
    }
  },
  mounted() {
    this.renderRadarChart()
  },
  methods: {
    renderRadarChart() {
      const plugin = {
        afterLayout: chart => {
          const scale = ['rgba(225, 245, 254, 1)', 'rgba(1, 87, 155, 1)']
          const f = chroma.scale(scale)
          const ctx = chart.chart.ctx
          ctx.save()
          const gradient = ctx.createRadialGradient(
            chart.scale.xCenter,
            chart.scale.yCenter,
            0,
            chart.scale.xCenter,
            chart.scale.yCenter,
            chart.width / 2
          )
          const minPercentage = (parseFloat(chart.scale.min) * 100) / 5 / 100
          const maxPercentage = (parseFloat(chart.scale.max) * 100) / 5 / 100
          const v0 = f(minPercentage)
            .css()
            .replace(/[^0-9,]/g, '')
          const v1 = f(maxPercentage)
            .css()
            .replace(/[^0-9,]/g, '')
          const rgb0 = `rgba(${v0.concat(',0.7')})`
          const rgb1 = `rgba(${v1.concat(',0.7')})`
          gradient.addColorStop(0, rgb0)
          gradient.addColorStop(1, rgb1)
          chart.data.datasets[0].backgroundColor = gradient
          ctx.restore()
        }
      }
      this._data._plugins.push(plugin)
      this.renderChart(this.data, this.options)
    }
  }
}
</script>
